import React from 'react'
import { cn } from '../../utils/helperFunctions'

export const ModalContainer = ({ children,className, ...props }) => {
  return (
    <div
      className={cn("fixed left-0 top-0 h-full w-full z-40",className)}
      {...props}
    >
      {children}
    </div>
  )
}

export const Modal = ({ children, className, ...props }) => {
  return (
    <div
      className={cn(
        'absolute left-[50%] top-[50%] z-20 translate-x-[-50%] translate-y-[-50%]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export const Overlay = ({ children, onClick,className, ...props }) => {
  return (
    <div
      className={cn(
        'absolute top-0 z-10 h-full w-full bg-foreground/50',
        className,
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  )
}

export default ModalContainer
